import withReducer from '../../store/withReducer'
import PatientReport from './container'
import reducer from './module'

export default withReducer('patientReport', reducer)(PatientReport)



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientReport/index.js